import React from "react";
import { withRouter } from "react-router-dom";
import Tile from "components/Tile";
import TileBody from "components/TileBody";
import PageTabs, { TAB } from "containers/BudgetHome/PageTabs";
import SnowfallDetails from "./SnowfallDetails";

const SnowfallCreate = (props) => {
    const { farm, budget } = props;
    const newSnowfall = {
        id: null,
        blockIds: [],
        snowfallMonths: [{ month: "January", amount: null, coverage: null }],
    };

    return (
        <Tile>
            <PageTabs farmId={farm.id} budget={budget} tab={TAB.CLIMATE} />
            <TileBody>
                <SnowfallDetails {...props} snowfall={newSnowfall} />
            </TileBody>
        </Tile>
    );
};

export default withRouter(SnowfallCreate);
